module.exports = __webpack_public_path__ + "aab33f9c7773fe54eeb2305321dd37e4.pdf";